import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 🔐 Firebase yapılandırman
const firebaseConfig = {
  apiKey: "AIzaSyAXV9hxt3AwQPEnHMF4LwDmM412MAxZ36U",
  authDomain: "ustmas-panel.firebaseapp.com",
  projectId: "ustmas-panel",
  storageBucket: "ustmas-panel.firebasestorage.app",
  messagingSenderId: "212536895603",
  appId: "1:212536895603:web:90819c4bc3eb2b8be12206"
};

const appName = "fatura-takip";
const app = getApps().find((existingApp) => existingApp.name === appName) || initializeApp(firebaseConfig, appName);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app, "gs://ustmas-panel.firebasestorage.app");
